












































import { Vue, Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";

import moment from "moment";

import FormActionButton from "@/components/falcon/shared/FormActionButton.vue";
import FilterOptionsForm from "@/components/falcon/shared/FilterOptionsForm.vue";
import SortOptionsForm from "@/components/falcon/shared/SortOptionsForm.vue";
import PaginationOptionsForm from "@/components/falcon/shared/PaginationOptionsForm.vue";
import DocumentsFiltersTypeFormField from "@/components/falcon/documents/DocumentsFiltersTypeFormField.vue";
import TableInlinePagination from "@/components/falcon/shared/TableInlinePagination.vue";

import { capitalizeFilter } from "@/filters/capitalize.filter";

import { GetMyInvoicesFalconFilterOptions } from "@/interfaces/falcon/get-my-invoices/get-my-invoices-falcon-filter-options";
import { FalconSortOptions } from "@/interfaces/falcon/shared/falcon-sort-options";
import { FalconPaginationOptions } from "@/interfaces/falcon/shared/falcon-pagination-options";
import { GetMyInvoicesFalconRequest } from "@/interfaces/falcon/get-my-invoices/get-my-invoices-falcon-request";

import { FalconDocumentsType } from "@/enums/falcon/documents/falcon-documents-type.enum";
import { RequestAlias } from "@/enums/request-alias.enum";
import { I18nMessageKey } from "@/enums/i18n-message-key.enum";
import { RouterPathName } from "@/enums/router-path-name.enum";

/**
 * @author Damian Kajzer <damian.kajzer@sowlgroup.com>
 * Falcon documents forms component
 */
@Component({
  components: {
    TableInlinePagination,
    PaginationOptionsForm,
    FormActionButton,
    DocumentsFiltersTypeFormField,
    SortOptionsForm,
    FilterOptionsForm
  },
  filters: {
    ...capitalizeFilter
  }
})
export default class DocumentsForms extends Vue {
  @Action("falconDocuments/getDocuments") private getDocuments!: (
    request: GetMyInvoicesFalconRequest
  ) => void;
  @Watch("$route", { immediate: true }) private routeUpdated(): void {
    this.isComplaintGuideActive =
      this.$route.name === RouterPathName.FalconDocumentsView &&
      !!this.$route.query.selectComplaintDocument;
  }
  private filterOptions: GetMyInvoicesFalconFilterOptions = {};
  private sortOptions: FalconSortOptions = {};
  private paginationOptions: FalconPaginationOptions = {};
  private documentsType: FalconDocumentsType | null = null;

  @State(state => state.falconDocuments.documentsTotalCount)
  documentsTotalCount!: number;
  initialDateFrom = moment()
    .subtract(7, "d")
    .format("YYYY-MM-DD");
  isComplaintGuideActive = false;
  requestAliasEnum = RequestAlias;
  i18nMessageKeyEnum = I18nMessageKey;

  mounted(): void {
    this.documentsFetchRequested();
  }

  setFilterOptions(filterOptions: GetMyInvoicesFalconFilterOptions): void {
    this.filterOptions = filterOptions;
    this.clearPaginationOptions();
  }

  setSortOptions(sortOptions: FalconSortOptions): void {
    this.sortOptions = sortOptions;
  }

  setDocumentsType(documentsType: FalconDocumentsType): void {
    this.documentsType = documentsType;
    this.clearPaginationOptions();
  }

  setPaginationOptions(paginationOptions: FalconPaginationOptions): void {
    this.paginationOptions = paginationOptions;
  }

  setPageSize(pageSize: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageSize
    });
  }

  setPageNumber(pageNumber: number): void {
    this.setPaginationOptions({
      ...this.paginationOptions,
      pageNumber
    });
    this.documentsFetchRequested();
  }

  documentsFetchRequested(): void {
    this.getDocuments({
      getMyInvoices: {
        finalDocuments: this.documentsType as FalconDocumentsType,
        filterOptions: this.filterOptions,
        sortOptions: this.sortOptions,
        ...this.paginationOptions
      }
    });
  }

  private clearPaginationOptions(): void {
    this.paginationOptions.pageNumber = 1;
  }
}
